enum actionTypes {
  FETCH_ACCOMMODATIONS = 'FETCH_ACCOMMODATIONS',
}

export default actionTypes;
